import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { log } from "../../../abstracts/utils/AbstractConsole";
import { fadeAndStopSound } from "../../../abstracts/utils/SoundUtils";
import { UCSoundNames } from "../../assetsLoader/UCAssetsNames";
import { UCFreespinIdlePresentation } from "../freespin/UCFreespinIdlePresentation";

export class UCSuperFreespinIdlePresentation extends UCFreespinIdlePresentation {
    constructor() {
        super(`UCSuperFreespinIdlePresentation`);
    }

    protected get gameMode(): AbstractGameMode {
        return AbstractGameMode.SUPER_FREESPIN;
    }

    protected onDefaultStart() {
        log(`${this.id} onDefaultStart()`, this.colorScheme);

        if (
            this.model.data.mode !== AbstractGameMode.SUPER_FREESPIN &&
            this.model.data.nextMode === AbstractGameMode.SUPER_FREESPIN
        ) {
            if (this.model.data.mode === AbstractGameMode.NORMAL) {
                this.keypad.setWin(-1);
            }

            const soundName =
                this.model.data.mode === AbstractGameMode.NORMAL
                    ? UCSoundNames.MAIN_MUSIC
                    : UCSoundNames.FREESPIN_MUSIC;

            fadeAndStopSound({
                name: soundName,
                duration: 0.5,
                from: 1,
                to: 0,
            });

            this.winView.showFreespinIntroScreen(
                this.onIntroScreenComplete.bind(this),
                this.model.data.freespinsLeft,
                true
            );
        } else {
            this.flowPresentationTimeline.resume();
        }
    }
}
